import { format } from "date-fns";
import ApiHelper from "../../common/utils/apiHelper";
import { getPusher } from "../../common/utils/pusher";
import { resolveEstimationResponse } from "../../common/utils/transport/pusherEstimation";
// actions / selectors
import { globalActionCreators, selectApiBaseUrl } from "../../common/store/modules/globalModule";
// helpers
import {
  getInitialTransportSearchState,
  getUniqueOfferTypes,
  mapAvailableAirportsToOptions
} from "./helpers/airlineModuleHelpers";
import { getTimePlusMinutesRoundedToNext5 } from "../../common/utils/helpers/getTimePlusMinutesRoundedToNext5";

// TODO: Set to false when /v1/airports backend is ready / set to true for mock
const USE_MOCK_AIRPORTS = false;
// TODO: Set to false when v1/airports/${iataCode}/transports backend is ready / set to true for mock
const USE_MOCK_AIRPORT_OFFERS = false;
// TODO: Set to false when v1/airports/${iataCode}/transports/${type} backend is ready / set to true for mock
const USE_MOCK_TRANSPORT_SEARCH = false;

const MOCK_AIRPORTS_RESPONSE = [
  {
    name: "Zurich Airport",
    iata_code: "ZRH",
    address: {
      city: "Kloten",
      formatted_address: "Vorfahrt Abflug 12, 8302 Kloten",
      place_id: "ChIJfXVSQEJ1kEcRWHaIRtZ3a8Y"
    }
  },
  {
    name: "Vienna airport",
    iata_code: "VIE",
    address: {
      city: "Vienna",
      formatted_address: "Flughafenstra\u00dfe 1, 1300 Vienna",
      place_id: null
    }
  },
  {
    name: "Munich Airport",
    iata_code: "MUC",
    address: {
      city: "Munich",
      formatted_address: "Nordallee 25, 85356 Munich",
      place_id: null
    }
  },
  {
    name: "Frankfurt Airport",
    iata_code: "FRA",
    address: {
      city: "Frankfurt am Main",
      formatted_address: "Hugo-Eckener-Ring 1, 60549 Frankfurt am Main",
      place_id: null
    }
  }
];

const MOCK_AIRPORT_OFFERS_RESPONSE = [
  {
    short_description:
      "Private taxi transfer from Zurich Airport to your destination. Convenient door-to-door transport.",
    name: "Taxi to your destination",
    type: "airport-taxi",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/839ceb47-604d-473c-9867-d8c242e27cb5/600308fdcfcbb71.png",
      name: null
    },
    highlight: "<p>Pick the first Airport Taxi in line.&nbsp;</p>\n\n<p>Taxis are available 24/7.</p>\n\n<p>test</p>"
  },
  {
    short_description: null,
    name: "Limousine Service",
    type: "limos4",
    image: null,
    highlight: null
  },
  {
    short_description: null,
    name: "CAT Service",
    type: "cat",
    image: null,
    highlight: null
  },
  {
    short_description:
      "Public transport across Switzerland including trains, buses, trams and boats. Reliable and well connected.",
    name: "Swiss public transport",
    type: "SBB",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/7088b123-11dd-4825-9947-a8a53e4e2c08/ad68bf8c6a0f7ef.png",
      name: null
    },
    highlight: null
  },
  {
    short_description: "Austrian public transport tickets with ÖBB. Book trains across Austria.",
    name: "Austrian public transport",
    type: "OBB",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/7088b123-11dd-4825-9947-a8a53e4e2c08/ad68bf8c6a0f7ef.png",
      name: null
    },
    highlight: null
  },
  {
    short_description:
      "Unlimited travel on Switzerland\u2019s public transport network. Ideal for exploring the country.",
    name: "Nationwide travel pass",
    type: "SWISS_TRAVEL_PASS",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/077ec02d-5663-4a7e-9538-b7f5756c04ec/4562fa27587f9a8.png",
      name: null
    },
    highlight: null
  },
  {
    short_description:
      "The Munich City Pass is the official guest card of the City of Munich. Enjoy free public transport and included attractions.",
    name: "Munich City Pass - All-Inclusive",
    type: "munich-city-pass",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
      name: null
    },
    highlight: "<p>Valid on Munich’s entire public transport network, including the Airport zone.</p>"
  },
  {
    short_description:
      "Free travel on all public transport in Frankfurt city incl. the airport (zones 5000 and 5090, 2nd class).",
    name: "Frankfurt Card",
    type: "frankfurt-card",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
      name: null
    },
    highlight: null
  },
  {
    short_description: "Vienna Airport Bus",
    name: "Vienna Airport Bus",
    type: "vienna-airport-bus",
    image: {
      url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/193fa4fb-024b-4e0c-9aa3-bd8fb123d9b9/3b75721abf6e3b1-332x118.png",
      name: null
    },
    highlight: null
  },
  {
    short_description: "Lufthansa Express Bus",
    name: "Lufthansa Express Bus",
    type: "lufthansa-express-bus",
    image: null,
    highlight: null
  },
  {
    short_description: "Long-distance train tickets with Deutsche Bahn.",
    name: "Deutsche Bahn",
    type: "deutsche-bahn",
    image: null,
    highlight: "<p>Direct long-distance train from the airport to the city centre.</p>"
  }
];

const MOCK_TRANSPORT_SEARCH_BY_TYPE: Record<string, any[]> = {
  SWISS_TRAVEL_PASS: [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/fc018649-c56e-4fa1-ab82-739ed3c6b29c/5ad1f702cb09eee.png",
        name: "5ad1f702cb09eee.png"
      },
      name: "Swiss Travel Pass 3 days",
      short_description: "Unlimited travel on Switzerland’s public transport network. Ideal for exploring the country.",
      highlight: null,
      type: "SWISS_TRAVEL_PASS",
      offer_code: "EWHCZBW",
      formatted_price: "254.00 CHF",
      miles_and_more: "1270 miles",
      details: {
        departure: null,
        destination: null,
        session_id: "01a06137-1b7f-7172-8d0f-617f05cfb668",
        passengers: [
          {
            first_name: "Get Local",
            last_name: "Transfer Hub",
            birthdate: "2001-09-02T10:23:16+02:00",
            member_card: false,
            price: "254.00",
            currency: "CHF",
            country_of_residence: "DE"
          }
        ]
      }
    }
  ],
  "munich-city-pass": [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
        name: "65249b87c14fafd.png"
      },
      name: "1 Day",
      short_description:
        "The Munich City Pass is the official guest card of the City of Munich. Enjoy free public transport and included attractions.",
      highlight: "<p>Valid on Munich’s entire public transport network, including the Airport zone.</p>",
      type: "munich-city-pass",
      offer_code: "MUNICH_CITY_PASS_1_DAY",
      formatted_price: "39.50 EUR",
      miles_and_more: "200 miles",
      details: {
        departure: null,
        destination: null,
        session_id: "mock-munich-city-pass-airline-session",
        passengers: [
          {
            first_name: "Get Local",
            last_name: "Transfer Hub",
            birthdate: "2001-09-02T10:23:16+02:00",
            country_of_residence: null,
            member_card: false,
            passenger_type: "Adult",
            price: "39.50",
            currency: "EUR"
          }
        ]
      }
    }
  ],
  "frankfurt-card": [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/zurich/390c0357-516c-45ae-91b6-152fb9996817/65249b87c14fafd.png",
        name: "65249b87c14fafd.png"
      },
      name: "Frankfurt Card 1 Day",
      short_description: "Public transport and attraction discounts in Frankfurt.",
      highlight: null,
      type: "frankfurt-card",
      offer_code: "FC-1DAY",
      formatted_price: "27.00 EUR",
      miles_and_more: "54 miles",
      details: {
        session_id: null,
        passengers: [
          {
            first_name: "Get Local",
            last_name: "Transfer Hub",
            price: "27.00",
            currency: "EUR"
          }
        ]
      }
    }
  ],
  "airport-taxi": [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/0627d23d-c838-4a32-8e36-19e28e1a1506/b5d6eda1eb32f30.png",
        name: "b5d6eda1eb32f30.png"
      },
      name: "Airport",
      short_description:
        "Private taxi transfer from Zurich Airport to your destination. Convenient door-to-door transport.",
      highlight:
        "<p>Pick the first Airport Taxi Zurich in line.</p>\n\n<p>Taxis are available from 6.00 AM to 11.35 PM.</p>\n\n<p>test Zurich</p>",
      type: "airport-taxi",
      offer_code: "EOGXMYA",
      formatted_price: "19.99 CHF",
      miles_and_more: "100 miles",
      details: {
        arrival_estimation_description: "12 – 18 min"
      }
    }
  ],
  SBB: [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/c3976cbb-c049-4f7c-8c91-b370724f3cae/82da2bb157c6383.png",
        name: "82da2bb157c6383.png"
      },
      name: "SBB Custom Route Offer",
      short_description:
        "Public transport across Switzerland including trains, buses, trams and boats. Reliable and well connected.",
      highlight: null,
      type: "SBB",
      offer_code: "EWPSYOU",
      formatted_price: "7.20 CHF",
      miles_and_more: "100 miles",
      details: {
        departure: {
          station_id: 8503016,
          name: "Zürich Flughafen",
          latitude: 47.450379,
          longitude: 8.562387,
          external_code: null
        },
        destination: {
          station_id: 8591071,
          name: "Zürich, Beckenhof",
          latitude: 47.384083,
          longitude: 8.540444,
          external_code: null
        },
        session_id: "01a06137-1dc4-725d-bb8e-5649cf0fdf9f",
        passengers: [
          {
            first_name: "Get Local",
            last_name: "Transfer Hub",
            birthdate: "2001-09-02T10:23:16+02:00",
            member_card: false,
            price: "7.20",
            currency: "CHF",
            country_of_residence: null
          }
        ]
      }
    }
  ],
  OBB: [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/7088b123-11dd-4825-9947-a8a53e4e2c08/ad68bf8c6a0f7ef.png",
        name: "ad68bf8c6a0f7ef.png"
      },
      name: "Austrian public transport",
      short_description: "Austrian public transport tickets with ÖBB. Book trains across Austria.",
      type: "OBB",
      offer_code: "ECKWOBBQ",
      formatted_price: "9.90 EUR",
      miles_and_more: "50 miles",
      details: {
        departure: {
          station_code: "ATVIE",
          name: "Wien Flughafen",
          latitude: 48.121,
          longitude: 16.563
        },
        destination: {
          station_code: "ATWIEWBF",
          name: "Wien Westbahnhof",
          latitude: 48.197,
          longitude: 16.337
        }
      }
    }
  ],
  limos4: [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/b8855c16-85f3-4be0-a9bf-32247feae382/f2853c4001ae450.png",
        name: "f2853c4001ae450.png"
      },
      name: "First Class (S-Class)",
      short_description:
        "Private limousine transfer with a professional driver. Direct and comfortable door-to-door service.",
      highlight: null,
      type: "limos4",
      offer_code: "EBDDXVC",
      formatted_price: "137.00 CHF",
      miles_and_more: "685 miles",
      details: {
        quote_id: "j9VVBNODRkHGneWN5spwN+qnl+OcWaQmhagb0zQWpns="
      }
    }
  ],
  cat: [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/e3c403c5-e647-49be-917c-1d967ea8cf7e/1d83039601a4eb1.png",
        name: "1d83039601a4eb1.png"
      },
      name: "City Airport Train Return Ticket",
      short_description:
        "Non-stop airport train between Vienna Airport and the city center. Fast and efficient connection.",
      highlight: null,
      type: "CAT",
      offer_code: "EQFBORU",
      formatted_price: "10.00 EUR",
      miles_and_more: "100 miles",
      details: null
    }
  ],
  "vienna-airport-bus": [
    {
      image: {
        url: "https://d1o0qt6ld1319s.cloudfront.net/dev/event/193fa4fb-024b-4e0c-9aa3-bd8fb123d9b9/3b75721abf6e3b1.png",
        name: "3b75721abf6e3b1.png"
      },
      name: "Vienna Airport Bus",
      short_description: "Vienna Airport Bus",
      highlight: null,
      type: "vienna-airport-bus",
      offer_code: "ESHEACC",
      formatted_price: "25.00 EUR",
      miles_and_more: "125 miles",
      details: {
        offer_id: "9a71c2f8-d44f-4de6-bb10-4768b5c359e9|0",
        vacant: true,
        departure: {
          station_code: "ATVIEVAB",
          country_code: "AT",
          name: "Vienna Airport",
          station_type: "bus_station",
          uic_station_code: null,
          street_and_number: "Schwechat",
          zip_code: "1300",
          time_zone: "Europe/Vienna",
          location: {
            lat: 48.11996841,
            lon: 16.56323433
          },
          latitude: 48.11996841,
          longitude: 16.56323433
        },
        destination: {
          station_code: "ATVIEWIE",
          country_code: "AT",
          name: "Wien Karlsplatz",
          station_type: "bus_station",
          uic_station_code: null,
          street_and_number: "Karlsplatz 1-3",
          zip_code: "",
          time_zone: "Europe/Vienna",
          location: {
            lat: 48.200811,
            lon: 16.369838
          },
          latitude: 48.200811,
          longitude: 16.369838
        },
        departure_time: "2026-09-04T11:00",
        arrival_time: "2026-09-04T11:26",
        session_id: "e9dac96e-94d3-48e1-8526-0a307a09c19f",
        passengers: [
          {
            first_name: null,
            last_name: null,
            birthdate: "2001-09-02T10:25:40+02:00",
            member_card: false,
            price: "25.00",
            currency: "EUR",
            country_of_residence: null
          }
        ],
        terms_and_conditions: "https://www.viennaairportbus.com/en/rechtliches/agb"
      }
    }
  ],
  "deutsche-bahn": [
    {
      image: null,
      name: "Deutsche Bahn Flexpreis",
      short_description: "Long-distance train tickets with Deutsche Bahn.",
      highlight: null,
      type: "deutsche-bahn",
      offer_code: "DB_FLEXPREIS",
      formatted_price: "147.75 EUR",
      miles_and_more: "739 miles",
      details: {
        offer_id: "mock-deutsche-bahn-offer",
        departure: {
          name: "Frankfurt(M) Flughafen Fernbf",
          location: {
            lat: 50.053,
            lon: 8.5698
          },
          latitude: 50.053,
          longitude: 8.5698
        },
        destination: {
          name: "Köln Hbf",
          street_and_number: "Trankgasse 11",
          location: {
            lat: 50.943,
            lon: 6.9589
          },
          latitude: 50.943,
          longitude: 6.9589
        },
        session_id: "mock-deutsche-bahn-session",
        passengers: [
          {
            first_name: null,
            last_name: null,
            passenger_type: "PNOS"
          }
        ]
      }
    }
  ],
  "lufthansa-express-bus": [
    {
      image: null,
      name: "Lufthansa Express Bus",
      short_description: "Lufthansa Express Bus",
      highlight: null,
      type: "lufthansa-express-bus",
      offer_code: "ABC123",
      formatted_price: "35.00 EUR",
      miles_and_more: "130 miles",
      details: {
        offer_id: "9a71c2f8-d44f-4de6-bb10-4768b5c359e9|0",
        departure: {
          name: "Vienna Airport",
          location: {
            lat: 48.11996841,
            lon: 16.56323433
          },
          latitude: 48.11996841,
          longitude: 16.56323433
        },
        destination: {
          name: "Wien Karlsplatz",
          location: {
            lat: 48.200811,
            lon: 16.369838
          },
          latitude: 48.200811,
          longitude: 16.369838
        },
        session_id: "e9dac96e-94d3-48e1-8526-0a307a09c19f",
        passengers: [
          {
            first_name: null,
            last_name: null,
            birthdate: "2001-09-02T10:25:40+02:00",
            member_card: false,
            price: "25.00",
            currency: "EUR",
            country_of_residence: null
          }
        ]
      }
    }
  ]
};

export const airlineActionTypes = {
  SET_DEPARTURE_DATE: "SET_DEPARTURE_DATE",
  SET_ARRIVAL_AIRPORT: "SET_ARRIVAL_AIRPORT",
  SET_FINAL_DESTINATION: "SET_FINAL_DESTINATION",
  SET_SEARCH_TIME: "SET_SEARCH_TIME",
  SET_MILES_AND_MORE_NUMBER: "SET_MILES_AND_MORE_NUMBER",
  SET_AVAILABLE_AIRPORTS: "SET_AVAILABLE_AIRPORTS",
  SET_AIRPORT_OFFERS: "SET_AIRPORT_OFFERS",
  SET_AIRPORT_OFFERS_ERROR: "SET_AIRPORT_OFFERS_ERROR",
  SET_SEARCH_ERROR: "SET_SEARCH_ERROR",
  TOGGLE_SEARCHING: "TOGGLE_SEARCHING",
  INIT_TRANSPORT_SEARCH_BY_TYPES: "INIT_TRANSPORT_SEARCH_BY_TYPES",
  SET_TRANSPORT_TYPE_LOADING: "SET_TRANSPORT_TYPE_LOADING",
  SET_TRANSPORT_TYPE_SUCCESS: "SET_TRANSPORT_TYPE_SUCCESS",
  SET_TRANSPORT_TYPE_ERROR: "SET_TRANSPORT_TYPE_ERROR",
  CLEAR_TRANSPORT_SEARCH_RESULTS: "CLEAR_TRANSPORT_SEARCH_RESULTS",
  RESET_AIRLINE_SEARCH: "RESET_AIRLINE_SEARCH"
};

export interface AirlineState {
  departureDate: Date | string | null;
  arrivalAirport: Record<string, any> | null;
  finalDestination: Record<string, any> | null;
  searchTime: string | null;
  milesAndMoreNumber: string;
  availableAirports: any[];
  isSearching: boolean;
  searchError: string | null;
  airportOffers: any[] | null;
  airportOffersError: string | null;
  transportSearchByType: Record<string, any>;
}

export const initialState: AirlineState = {
  departureDate: null,
  arrivalAirport: null,
  finalDestination: null,
  searchTime: null,
  milesAndMoreNumber: "",
  availableAirports: [],
  isSearching: false,
  searchError: null,
  airportOffers: null,
  airportOffersError: null,
  transportSearchByType: {}
};

const normalizeResponseData = (raw: any): any[] => {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "object") return [raw];
  return [];
};

const postAirportTransportByType = async ({
  apiUrl,
  iataCode,
  type,
  payload,
  pusher
}: {
  apiUrl: string;
  iataCode: string;
  type: string;
  payload: Record<string, any>;
  pusher: ReturnType<typeof getPusher>;
}) => {
  if (USE_MOCK_TRANSPORT_SEARCH) {
    await new Promise(resolve => setTimeout(resolve, 850 + Math.floor(Math.random() * 3000)));
    return MOCK_TRANSPORT_SEARCH_BY_TYPE[type] || [];
  }

  const response = await ApiHelper.post(`${apiUrl}/v1/airports/${iataCode}/transports/${type}`, {}, payload);
  const data = await resolveEstimationResponse(response?.data, {
    pusher,
    channelPrefix: `estimation.${type.toLowerCase()}`
  });
  return normalizeResponseData(data);
};

const airlineModule = (state: AirlineState = initialState, action: any): AirlineState => {
  switch (action.type) {
    case airlineActionTypes.SET_DEPARTURE_DATE:
      return {
        ...state,
        departureDate: action.departureDate
      };
    case airlineActionTypes.SET_ARRIVAL_AIRPORT:
      return {
        ...state,
        arrivalAirport: action.arrivalAirport
      };
    case airlineActionTypes.SET_FINAL_DESTINATION:
      return {
        ...state,
        finalDestination: action.finalDestination
      };
    case airlineActionTypes.SET_SEARCH_TIME:
      return {
        ...state,
        searchTime: action.searchTime
      };
    case airlineActionTypes.SET_MILES_AND_MORE_NUMBER:
      return {
        ...state,
        milesAndMoreNumber: action.milesAndMoreNumber
      };
    case airlineActionTypes.SET_AVAILABLE_AIRPORTS:
      return {
        ...state,
        availableAirports: action.availableAirports
      };
    case airlineActionTypes.SET_AIRPORT_OFFERS:
      return {
        ...state,
        airportOffers: action.airportOffers
      };
    case airlineActionTypes.SET_AIRPORT_OFFERS_ERROR:
      return {
        ...state,
        airportOffersError: action.airportOffersError
      };
    case airlineActionTypes.SET_SEARCH_ERROR:
      return {
        ...state,
        searchError: action.searchError
      };
    case airlineActionTypes.TOGGLE_SEARCHING:
      return {
        ...state,
        isSearching: action.isSearching
      };
    case airlineActionTypes.INIT_TRANSPORT_SEARCH_BY_TYPES: {
      const transportSearchByType = (action.types || []).reduce((acc: Record<string, any>, type: string) => {
        acc[type] = {
          ...getInitialTransportSearchState(),
          isLoading: true
        };
        return acc;
      }, {});
      return {
        ...state,
        transportSearchByType
      };
    }
    case airlineActionTypes.SET_TRANSPORT_TYPE_LOADING: {
      const currentTypeState = state.transportSearchByType?.[action.transportType] || getInitialTransportSearchState();
      return {
        ...state,
        transportSearchByType: {
          ...state.transportSearchByType,
          [action.transportType]: {
            ...currentTypeState,
            isLoading: action.isLoading
          }
        }
      };
    }
    case airlineActionTypes.SET_TRANSPORT_TYPE_SUCCESS: {
      const currentTypeState = state.transportSearchByType?.[action.transportType] || getInitialTransportSearchState();
      const data = Array.isArray(action.data) ? action.data : [];
      return {
        ...state,
        transportSearchByType: {
          ...state.transportSearchByType,
          [action.transportType]: {
            ...currentTypeState,
            data,
            isLoading: false,
            isSuccess: data.length > 0,
            error: null
          }
        }
      };
    }
    case airlineActionTypes.SET_TRANSPORT_TYPE_ERROR: {
      const currentTypeState = state.transportSearchByType?.[action.transportType] || getInitialTransportSearchState();
      return {
        ...state,
        transportSearchByType: {
          ...state.transportSearchByType,
          [action.transportType]: {
            ...currentTypeState,
            data: [],
            isLoading: false,
            isSuccess: false,
            error: action.error || "search.error"
          }
        }
      };
    }
    case airlineActionTypes.CLEAR_TRANSPORT_SEARCH_RESULTS:
      return {
        ...state,
        transportSearchByType: {}
      };
    case airlineActionTypes.RESET_AIRLINE_SEARCH:
      return {
        ...state,
        availableAirports: state.availableAirports
      };
    default:
      return state;
  }
};

export default airlineModule;

export const airlineActionCreators = {
  setDepartureDateAction: (departureDate: string | null) => ({
    type: airlineActionTypes.SET_DEPARTURE_DATE,
    departureDate
  }),
  setArrivalAirportAction: (arrivalAirport: any) => ({
    type: airlineActionTypes.SET_ARRIVAL_AIRPORT,
    arrivalAirport
  }),
  setFinalDestinationAction: (finalDestination: any) => ({
    type: airlineActionTypes.SET_FINAL_DESTINATION,
    finalDestination
  }),
  setSearchTimeAction: (searchTime: string | null) => ({
    type: airlineActionTypes.SET_SEARCH_TIME,
    searchTime
  }),
  setMilesAndMoreNumberAction: (milesAndMoreNumber: string) => ({
    type: airlineActionTypes.SET_MILES_AND_MORE_NUMBER,
    milesAndMoreNumber
  }),
  setSearchErrorAction: (searchError: string | null) => ({
    type: airlineActionTypes.SET_SEARCH_ERROR,
    searchError
  }),
  resetAirlineSearchAction: () => ({
    type: airlineActionTypes.RESET_AIRLINE_SEARCH
  }),
  clearTransportSearchResultsAction: () => ({
    type: airlineActionTypes.CLEAR_TRANSPORT_SEARCH_RESULTS
  }),
  getAirportOffersAction: (iataCode: string | null) => async (dispatch: any, getState: any) => {
    dispatch({
      type: airlineActionTypes.SET_AIRPORT_OFFERS,
      airportOffers: null
    });
    dispatch({
      type: airlineActionTypes.SET_AIRPORT_OFFERS_ERROR,
      airportOffersError: null
    });

    if (!iataCode) {
      dispatch({
        type: airlineActionTypes.CLEAR_TRANSPORT_SEARCH_RESULTS
      });
      return;
    }

    const apiUrl = selectApiBaseUrl(getState());

    dispatch(globalActionCreators?.toggleGlobalLoaderAction(true));

    try {
      let data: any[];

      // Mock until /v1/airports/{iata_code}/offers is implemented – remove this block when backend is ready
      if (USE_MOCK_AIRPORT_OFFERS) {
        await new Promise(resolve => setTimeout(resolve, 300));
        data = MOCK_AIRPORT_OFFERS_RESPONSE;
      } else {
        const response = await ApiHelper.get(`${apiUrl}/v1/airports/${iataCode}/transports`);
        data = response.data;
      }

      dispatch({
        type: airlineActionTypes.SET_AIRPORT_OFFERS,
        airportOffers: data || []
      });
      dispatch({
        type: airlineActionTypes.CLEAR_TRANSPORT_SEARCH_RESULTS
      });
    } catch (err) {
      dispatch({
        type: airlineActionTypes.SET_AIRPORT_OFFERS,
        airportOffers: []
      });
      dispatch({
        type: airlineActionTypes.SET_AIRPORT_OFFERS_ERROR,
        airportOffersError: "airline.airportOffersError"
      });
      dispatch({
        type: airlineActionTypes.CLEAR_TRANSPORT_SEARCH_RESULTS
      });
    } finally {
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
    }
  },
  getAvailableAirportsAction: () => async (dispatch: any, getState: any) => {
    const apiUrl = selectApiBaseUrl(getState());
    try {
      let data: any[];
      // Mock until /v1/airports is implemented – remove this block when backend is ready
      if (USE_MOCK_AIRPORTS) {
        await new Promise(resolve => setTimeout(resolve, 200));
        data = MOCK_AIRPORTS_RESPONSE;
      } else {
        const response = await ApiHelper.get(`${apiUrl}/v1/airports`);
        data = response.data;
      }
      const availableAirports = mapAvailableAirportsToOptions(data || []);
      dispatch({
        type: airlineActionTypes.SET_AVAILABLE_AIRPORTS,
        availableAirports
      });
      return availableAirports;
    } catch (err) {
      return [];
    } finally {
      dispatch(globalActionCreators?.toggleGlobalLoaderAction(false));
    }
  },
  searchTransfersAction: (milesAndMoreNumber: string) => async (dispatch: any, getState: any) => {
    const apiUrl = selectApiBaseUrl(getState());
    const { soketiAppKey, soketiWsHost } = getState().global;
    const { departureDate, arrivalAirport, finalDestination, airportOffers } = getState().airline;

    const iataCode: string = arrivalAirport?.iata_code || "";
    const transportTypes = getUniqueOfferTypes(airportOffers);

    dispatch({ type: airlineActionTypes.TOGGLE_SEARCHING, isSearching: true });
    dispatch({ type: airlineActionTypes.SET_SEARCH_ERROR, searchError: null });
    dispatch({ type: airlineActionTypes.INIT_TRANSPORT_SEARCH_BY_TYPES, types: transportTypes });

    try {
      if (!apiUrl) {
        dispatch({
          type: airlineActionTypes.SET_SEARCH_ERROR,
          searchError: "search.error"
        });
        return;
      }
      if (!iataCode || transportTypes.length === 0) {
        return;
      }

      const searchTime = getTimePlusMinutesRoundedToNext5();
      dispatch({ type: airlineActionTypes.SET_SEARCH_TIME, searchTime });

      const pusher = getPusher(soketiAppKey || "", soketiWsHost || "");

      const payload = {
        date: format(departureDate, "yyyy-MM-dd"),
        time: searchTime,
        departureAddress: arrivalAirport?.address?.formatted_address,
        departureAddressId: arrivalAirport?.address?.place_id,
        destinationAddress: finalDestination?.value?.description,
        destinationAddressId: finalDestination?.value?.place_id,
        milesAndMore: milesAndMoreNumber || ""
      };

      await Promise.allSettled(
        transportTypes.map(async (type: string) => {
          try {
            dispatch({
              type: airlineActionTypes.SET_TRANSPORT_TYPE_LOADING,
              transportType: type,
              isLoading: true
            });
            const data = await postAirportTransportByType({
              apiUrl,
              iataCode,
              type,
              payload,
              pusher
            });
            dispatch({
              type: airlineActionTypes.SET_TRANSPORT_TYPE_SUCCESS,
              transportType: type,
              data
            });
          } catch (error) {
            dispatch({
              type: airlineActionTypes.SET_TRANSPORT_TYPE_ERROR,
              transportType: type,
              error: "search.error"
            });
          }
        })
      );
    } catch (err) {
      dispatch({
        type: airlineActionTypes.SET_SEARCH_ERROR,
        searchError: "search.error"
      });
    } finally {
      dispatch({ type: airlineActionTypes.TOGGLE_SEARCHING, isSearching: false });
    }
  }
};
